// Plain text field validator

export default ({ mandatory = false, customError = null }) => ({
  type: 'string',
  presence: mandatory && { message: customError }
});
